import { HandleError, WrapNetworkCall } from '../page/actions';
import { AUTH_DEFINE_PASSWORD, AUTH_LOGIN, AUTH_LOGOUT, AuthActionTypes, AuthLoginAction } from './types';
import ServiceLocator from '../../services/ServiceLocator';
import { AppDispatcher, AsyncStateAction } from '../types';
import { Constants } from '../../api/Configuration';
import LoginResponse, { LoginResponseData } from '../../api/dtos/auth/LoginResponse';

export function RefreshTokenIfNeeded<T>(action: (dispatch: AppDispatcher) => Promise<T>, withLoading: boolean = false): AsyncStateAction {
    return async dispatch => {
        await WrapNetworkCall(dispatch, async () => {
            await WithRefreshToken(async () => {
                return await action(dispatch);
            }, dispatch);
        }, withLoading)
    };
}

let refreshTokenPromise: Promise<LoginResponse> | null = null;

export async function WithRefreshToken<T>(action: () => Promise<T>, dispatch: AppDispatcher): Promise<T | undefined> {
    try {
        let now = new Date(new Date().getTime() + 5 * 60000);
        let { expirationDate } = ServiceLocator.Authenticator.RefreshTokenInfo();

        if (now >= expirationDate) {
            let localPromise = refreshTokenPromise ??= ServiceLocator.AuthService.Refresh({
                refresh_token: ServiceLocator.Authenticator.RefreshTokenInfo().refreshToken,
                client_id: Constants.CLIENT_ID,
            });

            const response = await localPromise;

            if (response.is_success) {
                dispatch(LoggedIn(response.data));
            }
            else {
                dispatch(HandleError(response));
                ServiceLocator.Authenticator.Logout();
                return;
            }
        }
        else {
            console.log('token still valid don\'t need to refresh')
        }

        return await action();
    } finally {
        refreshTokenPromise = null;
    }
}

export function Logout(): AuthActionTypes {
    return {
        type: AUTH_LOGOUT
    }
}

export function LoggedIn(response: LoginResponseData): AuthActionTypes {
    const expirationTimestamp = new Date(new Date().getTime() + response.expires_in * 1000).getTime();

    let action: AuthLoginAction = {
        type: AUTH_LOGIN,
        user: {
            id: response.user.id,
            email: response.user.email,
            name: response.user.name,
            role: response.user.role,
        },
        accessToken: response.access_token,
        refreshToken: response.refresh_token,
        expirationDate: expirationTimestamp,
        tokenType: response.token_type
    };

    ServiceLocator.Authenticator.UseTokens(action.tokenType, action.accessToken, action.refreshToken, action.expirationDate);
    return action;
}

export function DefinePassword(): AuthActionTypes {
    return {
        type: AUTH_DEFINE_PASSWORD,
    }
}

